import dayjs from "dayjs";

export const getAccessCardExpiryStats = (
  employeeData = []
) => {
  const stats = {
    expired: [],
    oneToSevenDays: [],
    eightToThirtyDays: [],
    thirtyOneToSixtyDays: [],
  };

  employeeData.forEach((employee) => {
    if (!employee.access_card_expiry_date) return;

    const today = dayjs().startOf("day");

    const expiryDate = dayjs(
      employee.access_card_expiry_date
    ).startOf("day");

    const diffDays = expiryDate.diff(today, "day");

    if (diffDays <= 0) {
      stats.expired.push(employee);
    } else if (diffDays <= 7) {
      stats.oneToSevenDays.push(employee);
    } else if (diffDays <= 30) {
      stats.eightToThirtyDays.push(employee);
    } else if (diffDays <= 60) {
      stats.thirtyOneToSixtyDays.push(employee);
    }
  });

  return stats;
};